<template>
  <div class="footer">
    <div class="line"></div>
    <div class="logo">
      <img src="../../../assets/mobile/imgs/index/zjdlogo.png" alt="" >
    </div>
    <ul>
      <li v-for="(item,index) in list" :key="index">
        <img :src="item.img" alt="">
        <p>
          <span>{{ $t(item.txt1) }}</span>
          <span>{{ item.txt2 }}</span>
        </p>
      </li>
    </ul>
    <div class="qrcodes">
      <div>
        <img src="../../../assets/mobile/imgs/index/f6.png" alt="">
        <p>{{ $t("AMG[21]") || "中间带在线" }}</p>
      </div>
      <div>
        <img src="../../../assets/mobile/imgs/index/f7.png" alt="">
        <p>{{ $t("AMG[22]") || "中间带24小时" }}</p>
      </div>
      <div>
        <img src="../../../assets/mobile/imgs/index/f8.png" alt="">
        <p>{{ $t("AMG[23]") || "MediLink Global 中间带" }}</p>
      </div>
    </div>
    <div class="copyright" v-if="isYtEnv">
      <p>
        宇泰保险经纪（北京）有限公司©版权所有 ALL RIGHTS RESERVED.
      </p>
      <p>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          style="color: rgba(0,0,0,0.65);"
        >
          京ICP备 16001338号-4
        </a>
      </p>
    </div>
    <div class="copyright" v-else>
      <p>
        Copyright © 2008 - 2020 MediLink-Global. ALL RIGHTS RESERVED
      </p>
      <p>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          style="color: rgba(0,0,0,0.65);"
        >
        京ICP备 08007346号-1
        </a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isYtEnv: !!(process.env.NODE_ENV=='yt'),
      list: [
        {
          img: require('../../../assets/mobile/imgs/index/f1.png'),
          txt1: 'LOGIN[4]',
        },
        {
          img: require('../../../assets/mobile/imgs/index/f2.png'),
          txt1: 'LOGIN[5]',
          txt2: '400 880 8820'
        },
        {
          img: require('../../../assets/mobile/imgs/index/f3.png'),
          txt1: 'LOGIN[6]',
          txt2: '100022'
        },
        {
          img: require('../../../assets/mobile/imgs/index/f4.png'),
          txt1: 'LOGIN[7]',
          txt2: '+8610 8453 9719'
        },
        {
          img: require('../../../assets/mobile/imgs/index/f5.png'),
          txt1: 'LOGIN[8]',
          txt2: 'www.medilink-global.com.cn'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
.footer {
    width: 100vw;
    margin: 40px 0 0;
  .line {
    margin: 0 30px 29px;
    height: 1px;
    background: #EAEAEA;
  }
  .logo {
    display: flex;
    justify-content: center;
    height: 22px;
    img {
      width: 78px;
      height: 100%;
    }
  }
  ul {
    margin: 23px 30px 27px;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img {
        margin-right: 7px;
        width: 10px;
        height: 11px;
      }
      p {
        font-size: 11px;
        word-break: break-all;
        white-space: nowrap;
      }
    }
  }
  .qrcodes {
    display: flex;
    margin: 0 30px;
    img {
      width: 88px;
      margin-right: 25px;
      &:last-child {
        margin-right: 0;
      }
    }
    p {
      width: 88px;
      color: #333;
      font-size: 10px;
      text-align: center;
    }
  }
  .copyright {
    margin-top: 34px;
    background: #F8F8F8;
    text-align: center;
    padding: 9px 40px;
    font-size: 9px;
  }
}
</style>


